import { Box } from "@mui/material";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { FormClassRetire } from "../../assets/data/Constants";

const splitTextAtPeriods = (text: string, rule: string): string[] => {
  const sentences = text.split(rule);
  return sentences;
};

const contextText = `受領者変更は、退職者が死亡し、相続人が退職金を請求する場合に使用する機能です。\n相続人請求の場合には「はい」を選択して処理に進んでください。\n退職者ご本人が口座番号の不備等により再度請求を行う必要がある場合には「いいえ」を選択して金融機関変更の処理に進んでください。`;

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "退職者名",
    keyword: "retireStaffName",
    type: "text",
  },
  {
    title: "金融機関コード",
    keyword: "bBankCd",
    type: "text",
  },
  {
    title: "金融機関名",
    keyword: "bBankName",
    type: "text",
  },
  {
    title: "支店コード",
    keyword: "bBranchCd",
    type: "text",
  },
  {
    title: "支店名",
    keyword: "bBranchName",
    type: "text",
  },
  {
    title: "口座番号",
    keyword: "bAccountNo",
    type: "text",
  },
  {
    title: "口座名義",
    keyword: "bAccountHolderKana",
    type: "text",
  },
  {
    keyword: "accountName",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLR410028_02,
  },
  {
    title: "振込先金融機関",
    keyword: "financialInstitution",
    type: "bankSearch",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職手当金の振込金融機関を「振込先金融機関登録」ボタンを押して選択してください。",
  },
  {
    title: "金融機関コード",
    keyword: "aBankCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "金融機関名",
    keyword: "aBankName",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "支店コード",
    keyword: "aBranchCd",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "支店名",
    keyword: "aBranchName",
    type: "text",
    requiredIcon: true,
  },
  {
    title: "口座番号",
    keyword: "aAccountNo",
    type: "label",
    inputProps: { maxLength: 7 },
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職手当金振込先金融機関の口座番号です。7桁の番号をご入力ください。6桁の場合は、口座番号の前「0」をつけて入力してください。",
  },
  {
    title: "口座名義人名（半角ｶﾀｶﾅ）",
    keyword: "aAccountHolderKana",
    type: "name",
    requiredIcon: true,
    helpicon: true,
    useFurigana: true,
    hafWidth: true,
    convertToHalfwidth: true,
    convertBankFormat: true,
    helpText:
      "退職手当金振込先金融機関の口座名義（フリガナ）を入力してください。",
  },
  {
    title: "振込先金融口座が確認できる書類",
    keyword: "financialAccountConfirmFile",
    type: "fileUpload",
    requiredIcon: true,
    id: FormClassRetire["振込先金融口座が確認できる書類"],
  },
  {
    title: "氏名が変更されていることを確認できる書類",
    keyword: "nameChangedConfirmFile",
    type: "fileUpload",
    id: FormClassRetire["氏名が変更されていることを確認できる書類"],
  },
  {
    keyword: "accountName",
    type: "lineTitle",
    lineTitle: (
      <>
        {splitTextAtPeriods(labelids.labelid.LBLR410028_03, "\\n").map(
          (item, index) => {
            return (
              <Box key={index} className="tkInfoText">
                {item}
              </Box>
            );
          }
        )}
      </>
    ),
  },
];

const schema = {
  financialInstitution: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  aAccountNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  aAccountHolderKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^([ｱ-ﾝｦ0-9\\(\\)\\.\\-\\/ ]|([-])|([ｳｶ-ﾄﾊ-ﾎ]ﾞ)|([ﾊ-ﾎ]ﾟ))+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    minLength: {
      value: 1,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "1"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  financialAccountConfirmFile: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

export { fakeTableList, schema, contextText };
